import { Injectable } from '@angular/core'
import { ConfigInitializer, ConfigInitializerService, I18nConfig } from '@spartacus/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

@Injectable({ providedIn: 'root' })
export class EbI18nConfigInitializer implements ConfigInitializer {
  readonly scopes = ['i18n.fallbackLang']
  readonly configFactory = () => this.resolveConfig().toPromise()

  constructor(protected configInit: ConfigInitializerService) {}

  /**
   * Resolves the `fallbackLang` based on the default language from config `context.language` .
   */
  protected resolveConfig(): Observable<I18nConfig> {
    return this.configInit.getStable('context.language').pipe(
      map(config => ({
        i18n: {
          // the first language in the array is the default one
          fallbackLang: config?.context?.language?.[0]
        }
      }))
    )
  }
}
